var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.312 2.278A4.1 4.1 0 0 0 8.5 3.438a4.13 4.13 0 0 0-2.825-1.16 4.09 4.09 0 0 0-4.064 4.097c0 4.67 4.717 7.492 6.162 8.247a1.58 1.58 0 0 0 1.453 0c1.446-.754 6.163-3.577 6.163-8.245a4.096 4.096 0 0 0-4.077-4.1"
  })));
};
export default SvgHeart;